import { useEffect, useState } from "react";
import { TREE_INDENT_PX, TREE_ROOT_PADDING_PX } from "@/components/file-tree/TreeIndentGuides";

const SHIMMER_STYLE: React.CSSProperties = {
	borderRadius: "var(--radius-2)",
	background:
		"linear-gradient(90deg, var(--skeleton-base) 0%, var(--skeleton-highlight) 50%, var(--skeleton-base) 100%)",
	backgroundSize: "200% 100%",
	animation: "izanagi-skeleton-shimmer 1.4s ease-in-out infinite",
};

/** ツリー行を模したスケルトン。アイコン枠と可変幅のラベル枠を 1 行として描く。 */
function SkeletonRow({ depth, labelWidth }: { depth: number; labelWidth: string }) {
	return (
		<div
			className="flex h-[22px] items-center gap-x-1.5 px-2"
			style={{ paddingLeft: depth * TREE_INDENT_PX + TREE_ROOT_PADDING_PX }}
		>
			<div style={{ ...SHIMMER_STYLE, width: 16, height: 16, flexShrink: 0 }} />
			<div style={{ ...SHIMMER_STYLE, width: labelWidth, height: 12 }} />
		</div>
	);
}

const ROWS: { depth: number; labelWidth: string }[] = [
	{ depth: 0, labelWidth: "55%" },
	{ depth: 1, labelWidth: "70%" },
	{ depth: 1, labelWidth: "45%" },
	{ depth: 0, labelWidth: "40%" },
	{ depth: 1, labelWidth: "60%" },
];

/** ワークスペースファイルの初回取得中に表示するスケルトンローダー。 */
export function FileTreeSkeleton() {
	const [visible, setVisible] = useState(false);
	useEffect(() => {
		const id = setTimeout(() => setVisible(true), 100);
		return () => clearTimeout(id);
	}, []);

	if (!visible) return null;
	return (
		<div data-testid="file-tree-skeleton" style={{ paddingBottom: 4 }}>
			{ROWS.map((row, i) => (
				<SkeletonRow key={i} depth={row.depth} labelWidth={row.labelWidth} />
			))}
		</div>
	);
}
